<div class="session-history">
  <div class="session-header p-0">
    <div class="header-content m-b-8">
      <div class="header-content-title">
        {{ 'CONVERSATION_HISTORY_HEADING' | translate }} ({{ totalThreadsCount > 0 ? totalThreadsCount : sessionThreads.length }})
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="session-loading">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <span class="loading-text">{{ 'LOADING_SESSION_TEXT' | translate }}</span>
    </div>
  </div>

  <div *ngIf="!isLoading && sessionThreads.length === 0" class="session-empty">
    <div class="empty-content">
      <div class="empty-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" opacity="0.3" />
          <path d="M8 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
          <path d="M12 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4" />
        </svg>
      </div>
      <div class="empty-text">
         <h4>{{ 'NO_SESSIONS_FOUND' | translate }}</h4>
        <span class="empty-suggestion">{{ 'START_NEW_CHAT_SUGGESTION' | translate }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && sessionThreads.length > 0" 
       class="session-list scrollable-tab"
       #sessionListRef
       (scroll)="onSessionListScroll($event)">
    <div *ngFor="let thread of sessionThreads; let i = index" class="list-view">
      <div class="list-view-inner" [ngClass]="{'chat-active': thread.is_selected}">
        <div class="list-view-chatname-input">
          <button type="button" 
                  class="list-view-chatname flex-container-row" 
                  (click)="onSelectSession(thread)"
                  [title]="thread.thread_name">
            <span class="t-bottom t-no-arrow">
              {{ thread.thread_name }}
            </span>
            <div class="text-right chat-history-icons" id="chat-history-menu-icons">
              <button 
                class="t-left t-no-arrow"
                [attr.data-tooltip]="'MENU_TOOLTIP' | translate"
                (click)="positionChatMenu(thread, $event)" 
                id="chat-history-menu-icon">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>
            </div>
          </button>

          <!-- Dropdown Menu -->
          <div [ngClass]="{'show': thread.dropdownVisible}" class="chat-history-menu">
            <button 
              (click)="renameSession(thread, $event)"
              class="chat-history-rename-delete hover-effect-bg t-bottom t-no-arrow">
              <i class="icon-edit-3 p-r-5"></i> {{ 'RENAME_BUTTON' | translate }}
            </button>
            <button 
              *ngIf="showShareInHistory"
              (click)="shareSession(thread, $event)"
              class="chat-history-rename-delete hover-effect-bg t-bottom t-no-arrow">
              <img src="../../../assets/images/icon-share.svg" alt="Share" class="share-icon"> {{ 'SHARE_BUTTON' | translate }}
            </button>
            <button 
              (click)="confirmDelete(thread, $event)"
              class="chat-history-rename-delete hover-effect-bg t-top t-no-arrow">
              <i class="icon-trash-2 p-r-5"></i> {{ 'DELETE_BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Lazy loading spinner at bottom -->
    <div *ngIf="isLoadingMore" class="session-loading-more">
      <div class="loading-more-spinner"></div>
    </div>
  </div>
</div>
